export default "__VITE_ASSET__WOppOVpw__"